import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { EMyHomeEstimationTargets } from '../../types/estimationTarget';

const estimationTargetSlice = createSlice({
  initialState: EMyHomeEstimationTargets.flat,
  name: 'estimationTarget',
  reducers: {
    setEstimationTarget: (_, action: PayloadAction<EMyHomeEstimationTargets>) => action.payload,
  },
});

export const {
  reducer: estimationTargetReducer,
  actions: { setEstimationTarget },
} = estimationTargetSlice;
